import React from 'react';
import { Form } from 'antd';
import cn from 'classnames';
import classes from './AntdControlled.module.scss';
import useFormConfigContext from '../../hooks/useFormConfigContext';

const DecoratedField = ({ children, ...rest }) => {
  const { field } = rest;
  const { description, footNotePosition = 'bottom' } = field || {};
  if (!children) return null;
  return (
    <div className={cn(classes.decorated)}>
      <span
        className={cn(classes.decorated__content, {
          [classes['decorated__content--top']]: footNotePosition === 'bottom',
          [classes['decorated__content--bottom']]: footNotePosition === 'top',
        })}>
        {React.cloneElement(children, rest)}
      </span>
      <span
        className={cn(classes.decorated__footNote, {
          [classes['decorated__footnote--top']]: footNotePosition === 'top',
          [classes['decorated__footnote--bottom']]: footNotePosition === 'bottom',
        })}>
        {description}
      </span>
    </div>
  );
};

export const AntdFormItem = ({ field, children }) => {
  const { disabled } = useFormConfigContext();
  return (
    <Form.Item
      className={cn(classes.field)}
      label={field.label}
      name={field.name}
      rules={field.rules || []}>
      <DecoratedField field={{ disabled, ...field }}>{children}</DecoratedField>
    </Form.Item>
  );
};
